import { createRoutine } from 'redux-saga-routines'
import { ICallLogState } from './callLog.interface'

const initialCallLogState: ICallLogState = {
  callLogs: [],
  error: false,
  loading: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  },
}

export const getAllCallLogs = createRoutine('GET_ALL_CALLLOGS')
export const makeCall = createRoutine('MAKE_CALL')
export const getCallStatus = createRoutine('GET_CALL_STATUS')
export const clearCurrentCall = createRoutine('CLEAR_CURRENT_CALL')

export default function callLog(state = initialCallLogState, action: any) {
  switch (action.type) {
    case getAllCallLogs.TRIGGER:
      return { ...state, loading: true, callLogs: [], error: false, success: false }
    case getAllCallLogs.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        callLogs: action.payload.callLogs,
        meta: action.payload.meta,
        error: false
      }
    case getAllCallLogs.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
      case makeCall.TRIGGER:
        return { ...state, loading: true, error: false, success: false, currentCall: null }
      case makeCall.SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          currentCall : action.payload,
          error: false
        }
      case makeCall.FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: true
        }

      case getCallStatus.SUCCESS:
        return {
          ...state,
          currentCall: {...Object.assign(state.currentCall, action.payload)}
        }
      case clearCurrentCall.TRIGGER:
        return{
          ...state,
          currentCall : null
        }

    default:
      return state
  }
}
